/* global axios */

import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  retryFailed(id) {
    return axios.post(`${this.url}/${id}/retry_failed`);
  }

  getDeliveryRecipients(id, params = {}) {
    return axios.get(`${this.url}/${id}/delivery_recipients`, { params });
  }

  downloadRecipients(id, status = 'all') {
    return axios.get(`${this.url}/${id}/download_recipients`, {
      params: { status },
      responseType: 'blob',
    });
  }

  downloadFailedRecipients(id) {
    return this.downloadRecipients(id, 'failed');
  }

  syncDeliveryHistory() {
    return axios.post(`${this.url}/sync_delivery_history`);
  }
}

export default new CampaignsAPI();
